"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MinusCircleFill = {
    name: 'minus-circle',
    theme: 'fill',
    nameWithTheme: 'minus-circle-fill',
    tag: 'svg',
    attrs: {
        xmlns: 'http://www.w3.org/2000/svg',
        class: 'icon',
        viewBox: '0 0 1024 1024'
    },
    children: [
        {
            tag: 'path',
            attrs: {
                d: 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm192 472c0 4.4-3.6 8-8 8H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h368c4.4 0 8 3.6 8 8v48z'
            },
            children: []
        }
    ]
};
exports.default = MinusCircleFill;



//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@1.0.0@@ant-design/icons/lib/fill/MinusCircleFill.js
// module id = 607
// module chunks = 0 1